import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';
import { initGrowthStagesPredictionSettings } from './internal/growth_stages_prediction_settings';

onElelementExistRunOnce('.field_index_page_fields_list', () => {
  void import('./internal/field_index_page_fields_list')
    .then(({ default: Component }) => Component());
});

onElelementExistRunOnce(
  '.growth_stages_prediction_settings_index_page',
  initGrowthStagesPredictionSettings,
);
